import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from 'src/lib/utils';

const badgeVariants = cva(
  // A tag ("Edited", "Add-on"): a quiet rounded chip. A STATUS uses StatusLabel (a dot plus a
  // sentence-case word) instead (restyle, 2026-10-28).
  'inline-flex items-center rounded-full bg-secondary px-2.5 py-0.5 text-[13px] font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'text-[var(--color-accent-blue-dark)]',
        secondary: 'text-muted-foreground',
        destructive: 'text-[var(--color-danger)]',
        outline: 'text-muted-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps): React.JSX.Element {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
